import { render, staticRenderFns } from "./asset-details.vue?vue&type=template&id=94c495ce&scoped=true&"
import script from "./asset-details.vue?vue&type=script&lang=js&"
export * from "./asset-details.vue?vue&type=script&lang=js&"
import style0 from "./asset-details.vue?vue&type=style&index=0&id=94c495ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c495ce",
  null
  
)

export default component.exports